
const countries = require('i18n-iso-countries')
countries.registerLocale(require('i18n-iso-countries/langs/en.json'))

export default {
  props: {
    redirect: {
      type: Boolean,
      default: true
    },
    ischeckout: {
      type: String,
      default: 'false'
    }
  },
    data(){
        return {
          user:{username:'', password:'', country:'GB'},
          showLoginForm: !this.ischeckout === 'true',
          showRegisterForm: this.ischeckout === 'true',
          showPasswordForm:false,
          showPasswordResetForm:false,
          showPasswordRequestConfirmation:false,
          showPasswordResetConfirmation:false,
          token:'',
          selectedCountry: 'GB',
          error:{status:false,message:''},
          loggingIn: false,
        }
    },
  computed: {
    countries () {
      const list = countries.getNames('en', { select: 'official' })
      return Object.keys(list).map((key) => ({ value: key, label: list[key] }))
    },
    checkout() {
      const url = new URL(window.location).pathname
      console.log('URL: ',url);
      return url === '/checkout/'
    }
  },
  mounted() {
    // Add class to body so we can hide menu etc...
    // document.body.classList.add('fullscreen')
    this.showLogin()
    if(this.$route.query.token){
      this.token = this.$route.query.token.replace(/ /g, '+')
      this.showLoginForm = false
      this.showPasswordResetForm = true
    }
    if(this.$route.query.reset){
      this.showLoginForm = false
      this.showPasswordForm = true
    }
  },
  methods:{
    async login(lms){
    this.loggingIn = true
    this.error.status = false;
      const _user = await this.$store.dispatch('user/login', this.user)
      console.log('USER: ',_user)
      if(_user.user_id){
        console.log('Logged in ok: ',_user)
        // console.log('Checkout?  ',this.checkout)

        // If we have an order we need to assign it
        if(this.orderId !== null && Number.isInteger(this.orderId)){
          const _cart = await this.$store.dispatch('cart/assignCartServer')
          console.log('Assigned order ok: ',_cart)
        }

        if(lms && this.$props.redirect){
          await this.lmsLogin();
        } else if(this.checkout) {
          this.loggingIn = false
          this.$router.push('/checkout/')
        } else if(this.$props.redirect){
          this.loggingIn = false
          this.$router.push('/my-account/dashboard/')
        }else{
          this.loggingIn = false
          return false
        }


      }else{
        this.loggingIn = false
        console.log('login error' + _user)
        this.error.status = true
        this.error.message = _user
      }
    },

    async lmsLogin(){
    this.error.status = false;
      const _lmsUser = await this.$store.dispatch('user/lmsLogin', { ...this.user, source: 'compact login form' })
      console.log('LMS USER: ',_lmsUser)
      if(_lmsUser.session){
        this.loggingIn = false
        console.log('LMS logged in ok')
        // console.log('Checkout?  ',this.checkout)
        if(this.checkout) {
          this.$router.push('/checkout/')
        } else {
          this.$router.push('/my-account/dashboard/')
        }
      }else{
        this.loggingIn = false
        console.log('LMS login error', _lmsUser)
        // this.error.status = true
        // this.error.message = _lmsUser.error_message
        if(this.checkout) {
          this.$router.push('/checkout/')
        } else {
          this.$router.push('/my-account/dashboard/')
        }
      }
    },

    // async register(){
    //   this.error.status = false;
    //   const _register = await this.$store.dispatch('user/register', this.user)
    //   console.log('REGISTER RESULT: ',_register)
    //   console.log('REGISTER STATUS: ',_register.status);
    //   if(_register.id){
    //     console.log('Register OK, logging in...')
    //     // this.$router.push('/my-account/dashboard/')
    //     this.login(false);
    //   }else{
    //     console.log('registration error: ' + _register)
    //     this.error.status = true
    //     this.error.message = _register
    //   }
    // },

    async requestResetPassword(){
      console.log('requesting password reset')
      const _request = await this.$store.dispatch('user/requestResetPassword', this.user)
      console.log('REQUEST RESULT: ',_request)
      // console.log('REQUEST STATUS: ',_request.status);
      if(_request.data){
        console.log('link present', _request)
      this.showPasswordForm = false
      this.showPasswordRequestConfirmation = true
      }else{
        console.log('request error: ' + _request)
        this.error.status = true
        this.error.message = _request
      }
    },


    async resetPassword() {
      console.log('resetting password')
      const data = {
        token:this.token,
        password:this.user.password
      }
      const _reset = await this.$store.dispatch('user/resetPassword', data)
      console.log('RESET RESULT: ', _reset)

      if(_reset.data){
        this.showPasswordResetConfirmation = true
        this.showPasswordResetForm = false
        setTimeout(this.showLogin, 2500)

      } else{
        console.log('request error: ' + _reset)
        this.error.status = true
        this.error.message = _reset
      }
      // need to send id(from query param) or email here too
    },

    showLogin(){
      this.user = {username:'', password:''};
      this.error = {status:false,message:''};
      this.showLoginForm = true;
      this.showRegisterForm = false;
      this.showPasswordForm = false;
      this.showPasswordResetForm = false;
      this.showPasswordResetConfirmation = false;
    },
    showRegister(){
      this.user = {username:'', password:'', country:'GB'};
      this.error = {status:false,message:''};
      this.showRegisterForm = true;
      this.showLoginForm = false;
      this.showPasswordForm = false;
    },
    showPassword(){
      this.user = {username:'', password:''};
      this.error = {status:false,message:''};
      this.showPasswordForm = true;
      this.showLoginForm = false;
      this.showRegisterForm = false;
    }
  }
}
